import { Link } from "react-router-dom";
import { Camera, PackageSearch, ShieldCheck, Users } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

const ITEMS = [
  {
    icon: Camera,
    fr: "Numérisez vos reçus papier ou numériques en une photo.",
    en: "Scan paper or digital receipts with a single photo.",
  },
  {
    icon: PackageSearch,
    fr: "Retrouvez le vrai nom et l’image des produits, au lieu des codes illisibles.",
    en: "See real product names and images instead of cryptic codes.",
  },
  {
    icon: ShieldCheck,
    fr: "Suivez vos garanties et vos dates limites de retour.",
    en: "Track your warranties and return deadlines.",
  },
  {
    icon: Users,
    fr: "Partagez un reçu avec votre conjoint ou votre famille.",
    en: "Share a receipt with your partner or family.",
  },
] as const;

/** Short, crawlable presentation of ReFound on /download. */
export function DownloadHighlights() {
  const { language } = useLanguage();
  const isFr = language === "fr";
  return (
    <section className="mt-8 w-full text-left" aria-labelledby="download-highlights-title">
      <h2 id="download-highlights-title" className="text-base font-semibold text-foreground">
        {isFr ? "Ce que fait ReFound" : "What ReFound does"}
      </h2>
      <ul className="mt-3 space-y-3">
        {ITEMS.map(({ icon: Icon, fr, en }) => (
          <li key={en} className="flex items-start gap-3 text-sm leading-relaxed text-muted-foreground">
            <Icon className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
            <span>{isFr ? fr : en}</span>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs leading-relaxed text-muted-foreground">
        {isFr
          ? "Base de données principale hébergée au Canada. Aucune publicité. Vos données personnelles ne sont jamais vendues."
          : "Main database hosted in Canada. No ads. Your personal data is never sold."}{" "}
        <Link to={isFr ? "/" : "/en"} className="font-medium text-primary underline-offset-4 hover:underline">
          {isFr ? "En savoir plus sur ReFound" : "Learn more about ReFound"}
        </Link>
      </p>
    </section>
  );
}
